import { createContext, useContext } from 'react'
import type { WebsiteBranding } from '../types'

const defaultBranding: WebsiteBranding = {
  logoUrl: '',
  primaryColor: '#f97316',
  secondaryColor: '#1a1a1a',
  fontFamily: 'system-ui, -apple-system, sans-serif',
}

interface BrandingContextType {
  branding: WebsiteBranding
  isEditing: boolean
}

export const BrandingContext = createContext<BrandingContextType>({
  branding: defaultBranding,
  isEditing: false,
})

export function useBranding() {
  return useContext(BrandingContext)
}
